import clx from "classnames";
import Locale from "./core/Locale";
export default function AppDivider({ className, title }) {
  return (
    <div className={clx("flex items-center ml-2", className)}>
      {title && (
        <span className="block w-fit text-muted-fg">
          <Locale code={title} />
        </span>
      )}
      <div className={`border-t flex-1 ${title && "ml-2"}`} />
    </div>
  );
}
